import { LegalEntitySelectComponent } from './components/legal-entity-select.component';
// import { TrZonasComponent } from './components/rows/tr-zonas.component';
import { environment } from '../environments/environment';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgOptimizedImage } from '@angular/common'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { DashboardComponent } from './admin/pages/dashboard/dashboard.component';
import { ModalAddUnitComponent } from './components/modals/modal-add-unit.component';
import { SettlementComponent } from './admin/pages/settlement/settlement.component';
import { UnitComponent } from './components/unit/unit.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EmojiModule } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { TenantsComponent } from './admin/pages/tenants/tenants.component';
import { ServicesComponent } from './admin/pages/services/services.component';
import { AmenitiesComponent } from './admin/pages/amenities/amenities.component';
import { ProvidersComponent } from './admin/pages/providers/providers.component';
import { PaymentsComponent } from './admin/pages/payments/payments.component';
import { ReceiptsComponent } from './admin/pages/payments/receipts.component';
import { ServiceComponent } from './admin/pages/services/service.component';
import { UtilitesComponent } from './admin/pages/utilites/utilites.component';
import { CargaRecibosComponent } from './components/carga-recibos/carga-recibos.component';
import { Papa } from 'ngx-papaparse';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TenantComponent } from './admin/pages/tenants/tenant.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';

import { AuthService } from './shared/services/auth.service';
import { UsersComponent } from './admin/pages/users/users.component';
import { RolesComponent } from './admin/pages/roles/roles.component';

import { FullCalendarModule } from '@fullcalendar/angular';
import { MaintenancesComponent } from './admin/pages/maintenances/maintenances.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AmenityComponent } from './admin/pages/amenities/amenity.component';
import { FormFloorComponent } from './components/forms/form-floor.component';
import { FormUnitComponent } from './components/forms/form-unit.component';
import { FormSettlementComponent } from './components/forms/form-settlement.component';
import { ContractHistoryComponent } from './components/settlement/contract-history/contract-history.component';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ProfileComponent } from './admin/pages/users/profile.component';
import { NgxChartsModule }from '@swimlane/ngx-charts';

import { TenantSignInComponent } from './components/tenant-sign-in/tenant-sign-in.component';
import { TenantSignUpComponent } from './components/tenant-sign-up/tenant-sign-up.component';
import { PaymentComponent } from './admin/pages/payments/payment.component';
import { TenantProfileComponent } from './tenant/pages/tenant-profile/tenant-profile.component';
import { TenantBillsComponent } from './tenant/pages/tenant-bills/tenant-bills.component';
import { TenantBillComponent } from './tenant/pages/tenant-bills/tenant-bill/tenant-bill.component';
import { TenantPaymentsComponent } from './tenant/pages/tenant-payments/tenant-payments.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { TenantPaymentMethodsComponent } from './tenant/pages/tenant-payment-methods/tenant-payment-methods.component';
import { TenantPaymentMethodComponent } from './tenant/pages/tenant-payment-methods/tenant-payment-method/tenant-payment-method.component';
import { TenantDashboardComponent } from './tenant/pages/tenant-dashboard/tenant-dashboard.component';
import { TenantEditPaymentMethodComponent } from './tenant/pages/tenant-payment-methods/tenant-edit-payment-method/tenant-edit-payment-method.component';
import { TransactionSuccessComponent } from './tenant/pages/tenant-transactions/transaction-success/transaction-success.component';

import { ColorPickerModule } from 'ngx-color-picker';
import { ShowBillComponent } from './admin/pages/bills/show-bill.component';
import { AuditTrailOffcanvasComponent } from './shared/components/audit-trail-offcanvas.component';
import { GodModeToggleComponent } from './shared/components/god-mode-toggle.component';
import { BillTenantComponent } from './admin/pages/tenants/bill-tenant.component';
import { IndexSettlementComponent } from './admin/pages/settlement/index-settlement.component';
import { TanquesComponent } from './admin/pages/tanques/tanques.component';
import { TanqueCreateComponent } from './admin/pages/tanques/tanque-create.component';
import { TanqueEditComponent } from './admin/pages/tanques/tanque-edit.component';
import { FormTanqueComponent } from './components/forms/form-tanque.component';
import { CreateSettlementComponent } from './admin/pages/settlement/create-settlement.component';
import { FilterPipe } from './filter.pipe';

import { FormsModule } from '@angular/forms';
import { BuildingFloorsComponent } from './components/building-floors/building-floors.component';
import { FormTenantComponent } from './components/forms/form-tenant.component';
import { ProviderCreateComponent } from './admin/pages/providers/provider-create.component';
import { ProviderEditComponent } from './admin/pages/providers/provider-edit.component';
import { FormProvidersComponent } from './components/forms/form-providers.component';
import { FormAmenityComponent } from './components/forms/form-amenity.component';
import { AmenityCreateComponent } from './admin/pages/amenities/amenity-create.component';
import { ServiceCreateComponent } from './admin/pages/services/service-create.component';
import { FormServiceComponent } from './components/forms/form-service.component';
import { FormUserComponent } from './components/forms/form-user.component';
import { RoleCreateComponent } from './admin/pages/roles/role-create.component';
import { RoleEditComponent } from './admin/pages/roles/role-edit.component';
import { FormRoleComponent } from './components/forms/form-role.component';
import { ConfirmPasswordChangeComponent } from './components/confirm-password-change/confirm-password-change.component';
import { ItemTenantComponent } from './item-tenant/item-tenant.component';
import { ComercialSettlementsComponent } from './admin/pages/settlement/comercial-settlements.component';
import { UnpaidComponent } from './admin/pages/payments/unpaid.component';
import { ItemServiceComponent } from './components/items/item-service.component';
import { ItemTinyTenantComponent } from './components/items/item-tiny-tenant.component';
import { ItemTinyUserComponent } from './components/items/item-tiny-user.component';
import { BillsSettlementComponent } from './admin/pages/settlement/bills-settlement.component';
import { TanqueGaugeComponent } from './admin/pages/tanques/tanque-gauge.component';
import { ItemItemProviderComponent } from './components/items/item-item-provider.component';
import { ItemTransactionComponent } from './components/items/item-transaction.component';
import { TechniciansComponent } from './admin/pages/technicians/technicians.component';
import { TechnicianEditComponent } from './admin/pages/technicians/technician-edit.component';
import { TechnicianCreateComponent } from './admin/pages/technicians/technician-create.component';
import { FormTechnicianComponent } from './components/forms/form-technician.component';
import { ItemBillComponent } from './components/items/item-bill.component';
import { RefuelsComponent } from './admin/pages/refuels/refuels.component';
import { OrdersComponent } from './admin/pages/orders/orders.component';
import { ModalOptionsPayComponent } from './components/modals/modal-options-pay.component';
import { RefuelEditComponent } from './admin/pages/refuels/refuel-edit.component';
import { RefuelCreateComponent } from './admin/pages/refuels/refuel-create.component';
import { OrderCreateComponent } from './admin/pages/orders/order-create.component';
import { OrderEditComponent } from './admin/pages/orders/order-edit.component';
import { FormRefuelComponent } from './components/forms/form-refuel.component';
import { FormOrderComponent } from './components/forms/form-order.component';
import { InvoicesComponent } from './admin/pages/invoices/invoices.component';
import { InvoiceCreateComponent } from './admin/pages/invoices/invoice-create.component';

import { BreadcrumbComponent, BreadcrumbItemDirective }  from "xng-breadcrumb";
import { TenantInvoiceComponent } from './tenant/pages/tenant-invoice/tenant-invoice.component';
import { TenantInvoiceListComponent } from './tenant/pages/tenant-invoice-list/tenant-invoice-list.component';
import { ItemPaymentMethodComponent } from './components/items/item-payment-method.component';
import { ItemTanqueComponent } from './components/items/item-tanque.component';
import { ItemOrderComponent } from './components/items/item-order.component';
import { ReceiptBreakdownComponent } from './components/receipt-breakdown/receipt-breakdown.component';
import { PaymentConceptsComponent } from './admin/pages/payment-concepts/payment-concepts.component';
import { ConceptEditComponent } from './admin/pages/payment-concepts/concept-edit.component';
import { ConceptCreateComponent } from './admin/pages/payment-concepts/concept-create.component';
import { FormPaymentConceptComponent } from './components/forms/form-payment-concept.component';
import { ItemConceptComponent } from './components/items/item-concept.component';
import { ItemFormConceptComponent } from './components/items/item-form-concept.component';
import { ReceiptReadsComponent } from './components/receipt-reads/receipt-reads.component';
import { ItemInvoiceComponent } from './components/items/item-invoice.component';
import { BillCommercialComponent } from './admin/pages/commercials/bill-commercial.component';
import { TaskCreateComponent } from './admin/pages/maintenances/tasks/task-create.component';
import { TaskEditComponent } from './admin/pages/maintenances/tasks/task-edit.component';
import { FormTaskComponent } from './components/forms/form-task.component';
import { TaskIndexComponent } from './admin/pages/maintenances/tasks/task-index.component';
import { ModalAddBuildingComponent } from './components/modals/modal-add-building.component';
import { CategoryIndexComponent } from './admin/pages/maintenances/categories/category-index.component';
import { CategoryCreateComponent } from './admin/pages/maintenances/categories/category-create.component';
import { CategoryEditComponent } from './admin/pages/maintenances/categories/category-edit.component';
import { FormTaskCategoryComponent } from './components/forms/form-task-category.component';
import { BillsTenantsComponent } from './admin/pages/tenants/bills-tenants.component';
import { BuildingUnitsComponent } from './components/building-units/building-units.component';
import { UnitDetailsComponent } from './components/unit-details/unit-details.component';
import { ItemTaskComponent } from './components/items/item-task.component';
import { ItemTinyTaskComponent } from './components/items/item-tiny-task.component';
import { CommercialsComponent } from './admin/pages/commercials/commercials.component';
import { CommercialComponent } from './admin/pages/commercials/commercial.component';
import { InvoiceShowComponent } from './admin/pages/invoices/invoice-show.component';
import { AmenityCalendarComponent } from './admin/pages/amenities/amenity-calendar.component';
import { AmenityTasksComponent } from './admin/pages/amenities/amenity-tasks.component';
import { AmenityTaskCreateComponent } from './admin/pages/amenities/amenity-task-create.component';
import { AmenityTaskEditComponent } from './admin/pages/amenities/amenity-task-edit.component';
import { InvoiceComplementComponent } from './admin/pages/invoices/invoice-complement.component';
import { InvoiceGlobalComponent } from './admin/pages/invoices/invoice-global.component';
import { ItemBillPendingComponent } from './components/items/item-bill-pending.component';
import { ModalInvoiceComplementComponent } from './components/modals/modal-invoice-complement.component';
import { ItemSettlementComponent } from './components/items/item-settlement.component';
import { TenantInvoicesComponent } from './tenant/pages/tenant-invoices/tenant-invoices.component';
import { TenantInvoiceShowComponent } from './tenant/pages/tenant-invoices/tenant-invoice-show/tenant-invoice-show.component';
import { InvoiceCreateGlobalComponent } from './admin/pages/invoices/invoice-create-global.component';
import { ItemBillInvoiceComponent } from './components/items/item-bill-invoice.component';
import { ProfileIndexComponent } from './admin/pages/profiles/profile-index.component';
import { ProfileEditComponent } from './admin/pages/profiles/profile-edit.component';
import { ProfileCreateComponent } from './admin/pages/profiles/profile-create.component';
import { ProfileShowComponent } from './admin/pages/profiles/profile-show.component';
import { InvoiceDashboardComponent } from './admin/pages/invoices/invoice-dashboard.component';
import { FilterAdvancedComponent } from './components/filters/filter-advanced.component';
import { InvoiceCreditnoteComponent } from './admin/pages/invoices/invoice-creditnote.component';
import { InvoiceCreditnoteCreateComponent } from './admin/pages/invoices/invoice-creditnote-create.component';
import { ItemProfileComponent } from './components/items/item-profile.component';
import { FormProfileComponent } from './components/forms/form-profile.component';
import { ItemInvoiceGlobalComponent } from './components/items/item-invoice-global.component';
import { ItemInvoiceNotaComponent } from './components/items/item-invoice-nota.component';
import { TenantUserEditComponent } from './admin/pages/tenants/tenant-user-edit.component';
import { FormConceptsComponent } from './components/forms/form-concepts.component';
import { ModalInvoiceNotaComponent } from './components/modals/modal-invoice-nota.component';
import { ItemCommercialComponent } from './components/items/item-commercial.component';
import { FormAbilityComponent } from './components/forms/form-ability.component';
import { FormReadingComponent } from './components/forms/form-reading.component';
import { CurrencyToTextPipe } from './pipes/currency-to-text.pipe';
import { IndexZoneComponent } from './admin/pages/zones/index-zone.component';
import { EditZoneComponent } from './admin/pages/zones/edit-zone.component';
import { CreateZoneComponent } from './admin/pages/zones/create-zone.component';
import { FormZoneComponent } from './components/forms/form-zone.component';
import { IndexReportsComponent } from './admin/pages/reports/index-reports/index-reports.component';
import { IndexBalancesComponent } from './admin/pages/payments/index-balances.component';
import { GenerateComponent } from './admin/pages/payments/generate.component';
import { ToolIndexComponent } from './admin/pages/tasks/tools/tool-index.component';
import { ToolEditComponent } from './admin/pages/tasks/tools/tool-edit.component';
import { ToolCreateComponent } from './admin/pages/tasks/tools/tool-create.component';
import { FormToolComponent } from './components/forms/form-tool.component';
import { SkillIndexComponent } from './admin/pages/tasks/skills/skill-index.component';
import { SkillEditComponent } from './admin/pages/tasks/skills/skill-edit.component';
import { SkillCreateComponent } from './admin/pages/tasks/skills/skill-create.component';
import { VehiclesIndexComponent } from './admin/pages/tasks/vehicles/vehicles-index.component';
import { VehiclesEditComponent } from './admin/pages/tasks/vehicles/vehicles-edit.component';
import { VehiclesCreateComponent } from './admin/pages/tasks/vehicles/vehicles-create.component';
import { BuilderIndexComponent } from './admin/pages/tasks/builder/builder-index.component';
import { BuilderEditComponent } from './admin/pages/tasks/builder/builder-edit.component';
import { BuilderCreateComponent } from './admin/pages/tasks/builder/builder-create.component';
import { FormSkillComponent } from './components/forms/form-skill.component';
import { FormVehicleComponent } from './components/forms/form-vehicle.component';
import { FormBuilderComponent } from './components/forms/form-builder.component';
import { ReceiptTinyComponent } from './components/receipt-tiny/receipt-tiny.component';
import { ItemBalanceComponent } from './components/items/item-balance.component';
import { MeterIndexComponent } from './admin/pages/gas-meters/meter-index.component';
import { MeterEditComponent } from './admin/pages/gas-meters/meter-edit.component';
import { MeterCreateComponent } from './admin/pages/gas-meters/meter-create.component';
import { FormGasMeterComponent } from './components/forms/form-gas-meter.component';
import { ItemGasMeterComponent } from './components/items/item-gas-meter.component';
import { ItemTinyGasMeterComponent } from './components/items/item-tiny-gas-meter.component';
import { ItemSkillComponent } from './components/items/item-skill.component';
import { ItemVehicleComponent } from './components/items/item-vehicle.component';
import { ItemToolComponent } from './components/items/item-tool.component';
import { ModalWorkScheduleComponent } from './components/modals/modal-work-schedule.component';
import { ModalVehiclesComponent } from './components/modals/modal-vehicles.component';
import { ModalSkillsComponent } from './components/modals/modal-skills.component';
import { ModalToolsComponent } from './components/modals/modal-tools.component';
import { ActivityIndexComponent } from './admin/pages/tasks/activities/activity-index.component';
import { ActivityEditComponent } from './admin/pages/tasks/activities/activity-edit.component';
import { ActivityCreateComponent } from './admin/pages/tasks/activities/activity-create.component';
import { ActivityTypeIndexComponent } from './admin/pages/tasks/activity-types/activity-type-index.component';
import { ActivityTypeEditComponent } from './admin/pages/tasks/activity-types/activity-type-edit.component';
import { ActivityTypeCreateComponent } from './admin/pages/tasks/activity-types/activity-type-create.component';
import { FormActivityComponent } from './components/forms/form-activity.component';
import { FormActivityTypeComponent } from './components/forms/form-activity-type.component';
import { DndModule } from 'ngx-drag-drop';
import { CountUpDirective } from './count-up.directive';
import { IndexChartComponent } from './components/charts/index-chart/index-chart.component';
import { BarChartComponent } from './components/charts/bar-chart/bar-chart.component';
import { DashboardSettlementComponent } from './admin/pages/settlement/dashboard-settlement.component';
import { DashboardTechniciansComponent } from './admin/pages/technicians/dashboard-technicians.component';
import { HolidaysComponent } from './admin/pages/tasks/holidays/holidays.component';
import { ModalHolidayComponent } from './components/modals/modal-holiday.component';
import { TaskReviewComponent } from './admin/pages/maintenances/tasks/task-review.component';
import { MapComponent } from './components/map/map.component';
import { ItemRefuelComponent } from './components/items/item-refuel.component';
import { ModalSetPriceComponent } from './components/modals/modal-set-price.component';
import { InvoiceCanceledComponent } from './admin/pages/invoices/invoice-canceled.component';
import { ItemInvoiceCanceledComponent } from './components/items/item-invoice-canceled.component';
import { ModalInvoiceCancelComponent } from './components/modals/modal-invoice-cancel.component';
import { InvoiceShowGlobalComponent } from './admin/pages/invoices/invoice-show-global.component';
import { UserCreateComponent } from './admin/pages/users/user-create.component';
import { ItemTaskTenantComponent } from './components/items/item-task-tenant.component';
import { CalendarEventComponent } from './components/calendar-event/calendar-event.component';
import { ItemPriceComponent } from './components/items/item-price.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { NotificationsComponent } from './admin/pages/notifications/notifications.component';
import { UnassignedComponent } from './admin/pages/maintenances/tasks/unassigned.component';
import { ItemUnassignedComponent } from './components/items/item-unassigned.component';
import { TaskRefuelComponent } from './admin/pages/maintenances/tasks/task-refuel.component';
import { ModalAsignTaskComponent } from './components/modals/modal-asign-task.component';
import { ModalVehicleAsignComponent } from './components/modals/modal-vehicle-asign.component';
import { DashboardCommercialComponent } from './admin/pages/commercials/dashboard-commercial.component';
import { GaugeChartComponent } from './components/charts/gauge-chart/gauge-chart.component';
import { initializeApp } from "firebase/app";
import { NotifyFloaterComponent } from './components/notify-floater/notify-floater.component';
import { ItemTaskRefuelComponent } from './components/items/item-task-refuel.component';
import { ModalAsignTaskOperatorComponent } from './components/modals/modal-asign-task-operator.component';
import { SearchTenantsComponent } from './components/search-tenants/search-tenants.component';
import { TasksDashboardComponent } from './admin/pages/maintenances/tasks/tasks-dashboard.component';
import { FilterBasicComponent } from './components/filters/filter-basic.component';
import { ModalInvoiceConfigComponent } from './components/modals/modal-invoice-config.component';
import { InvoiceUploaderComponent } from './admin/pages/invoices/invoice-uploader.component';
import { ItemSmTenantComponent } from './components/items/item-sm-tenant.component';
import { ModalTenantComponent } from './components/modals/modal-tenant.component';
import { ModalGasMeterComponent } from './components/modals/modal-gas-meter.component';
import { FilterFullComponent } from './components/filters/filter-full.component';
import { InvoiceGenericComponent } from './admin/pages/invoices/invoice-generic.component';
import { ModalBillVerifyComponent } from './components/modals/modal-bill-verify.component';
import { ItemInvoiceGenericComponent } from './components/items/item-invoice-generic.component';
import { TransactionFailComponent } from './tenant/pages/tenant-transactions/transaction-fail/transaction-fail.component';
import { CreateCustomBillComponent } from './admin/pages/bills/create-custom-bill.component';
import { BarChartConsumptionsComponent } from './components/charts/bar-chart-consumptions/bar-chart-consumptions.component';
import { PieChartPortfolioComponent } from './components/charts/pie-chart-portfolio/pie-chart-portfolio.component';
import { LineChartConsumptionComponent } from './components/charts/line-chart-consumption/line-chart-consumption.component';
import { ProfileDashboardComponent } from './admin/pages/profiles/profile-dashboard.component';
import { TransactionsPaymentsComponent } from './admin/pages/payments/transactions-payments.component';
import { ReportInvoicesIngresoComponent } from './components/reports/report-invoices-ingreso.component';
import { ReportInvoicesCanceledComponent } from './components/reports/report-invoices-canceled.component';
import { ReportInventoryComponent } from './components/reports/report-inventory.component';
import { ReportInvoicesGlobalComponent } from './components/reports/report-invoices-global.component';
import { ReportInvoicesNotasComponent } from './components/reports/report-invoices-notas.component';
import { ReportInvoicesGenericComponent } from './components/reports/report-invoices-generic.component';
import { ModalInvoicesGenericComponent } from './components/reports/modal-invoices-generic.component';
import { ModalInvoicesCanceledComponent } from './components/reports/modal-invoices-canceled.component';
import { ModalInvoicesGlobalComponent } from './components/reports/modal-invoices-global.component';
import { ModalInvoicesIngresoComponent } from './components/reports/modal-invoices-ingreso.component';
import { ModalInvoicesNotasComponent } from './components/reports/modal-invoices-notas.component';
import { RefuelShowComponent } from './admin/pages/refuels/refuel-show.component';
import { StlBarChartConsumptionsComponent } from './components/charts/stl-bar-chart-consumptions.component';
import { AnovaLineChartConsumptionsComponent } from './components/charts/anova-line-chart-consumptions.component';
import { ItemBillPaidComponent } from './components/items/item-bill-paid.component';
import { FilterSemiComponent } from './components/filters/filter-semi.component';
import { ModalGasMeterMaintenanceComponent } from './components/modals/modal-gas-meter-maintenance.component';
import { ContractUnitComponent } from './components/contract-unit.component';
import { ContractSettlementComponent } from './components/contract-settlement.component';
import { ModalAddContractComponent } from './components/modals/modal-add-contract.component';
import { FormContractComponent } from './components/forms/form-contract.component';
import { ItemContractComponent } from './components/items/item-contract.component';
import { FormPublicRecordComponent } from './components/forms/form-public-record.component';
import { SignInInvoiceComponent } from './components/sign-in-invoice/sign-in-invoice.component';
import { ItemTenantInvoiceComponent } from './components/items/item-tenant-invoice.component';
import { InvoiceAcceptanceComponent } from './admin/pages/invoices/invoice-acceptance.component';
import { ModalSetBillDateComponent } from './components/modals/modal-set-bill-date.component';
import { ContractIndexComponent } from './admin/pages/contracts/contract-index.component';
import { ContractEditComponent } from './admin/pages/contracts/contract-edit.component';
import { ContractTypesIndexComponent } from './admin/pages/contracts/contract-types-index.component';
import { ContractTypesEditComponent } from './admin/pages/contracts/contract-types-edit.component';
import { ItemContractTypesComponent } from './components/items/item-contract-types.component';
import { FormContractTypesComponent } from './components/forms/form-contract-types.component';
import { MeterUnitComponent } from './components/meter-unit.component';
import { ModalGasMeterMaintenanceRemoveComponent } from './components/modals/modal-gas-meter-maintenance-remove.component';
import { FormTenantFiscalComponent } from './components/forms/form-tenant-fiscal.component';
import { FormTenantAddressComponent } from './components/forms/form-tenant-address.component';
import { FormUserPasswordComponent } from './components/forms/form-user-password.component';
import { ModalUserPasswordComponent } from './components/modals/modal-user-password.component';
import { ModalUserFormComponent } from './components/modals/modal-user-form.component';
import { TreeViewComponent } from './components/tree-view/tree-view.component';
import { HistoricConsumptionsComponent } from './components/historic-consumptions/historic-consumptions.component';
import { HistoricConsumptionsFormComponent } from './components/historic-consumptions-form/historic-consumptions-form.component';
import { ModalUnitComponent } from './components/modals/modal-unit.component';
import { UnitPaymentsComponent } from './components/unit-payments/unit-payments.component';
import { ModalAddFloorComponent } from './components/modals/modal-add-floor.component';
import { ItemBillTinyComponent } from './components/items/item-bill-tiny.component';
import { TenantUnitsComponent } from './components/tenant-units/tenant-units.component';
import { ModalInvoicesGenericCanceledComponent } from './components/reports/modal-invoices-generic-canceled.component';
import { ReportInvoicesGenericCanceledComponent } from './components/reports/report-invoices-generic-canceled.component';
import { FullFilterComponent } from './components/offcanvas/full-filter.component';
import { OffcanvasNavbarComponent } from './components/offcanvas/offcanvas-navbar.component';
import { TrPaymentsComponent } from './components/rows/tr-payments.component';
import { TrTransactionsComponent } from './components/rows/tr-transactions.component';
import { TrSettlementComponent } from './components/rows/tr-settlement.component';
import { IndexInventoryComponent } from './admin/pages/inventory/index-inventory.component';

import { FormPurchaseOrderComponent } from './components/forms/form-purchase-order.component';
import { FormProviderComponent } from './components/forms/form-provider.component';
import { TrInventoryComponent } from './components/rows/tr-inventory.component';
import { TrProviderComponent } from './components/rows/tr-provider.component';
import { TrPurchaseOrderComponent } from './components/rows/tr-purchase-order.component';
import { TrTaskComponent } from './components/rows/tr-task.component';
import { TrTanquesComponent } from './components/rows/tr-tanques.component';
import { TrOrderComponent } from './components/rows/tr-order.component';
import { TrRefuelComponent } from './components/rows/tr-refuel.component';
import { TrZonasComponent } from './components/rows/tr-zonas.component';
import { TrTenantComponent } from './components/rows/tr-tenant.component';

import { NavPaymentsComponent } from './components/navs/nav-payments.component';
import { NavInvoicesComponent } from './components/navs/nav-invoices.component';
import { InvoiceCsvExportButtonComponent } from './admin/pages/invoices/invoice-csv-export-button.component';
import { NavSettlementsComponent } from './components/navs/nav-settlements.component';
import { NavTasksComponent } from './components/navs/nav-tasks.component';
import { NavAdministrationComponent } from './components/navs/nav-administration.component';

import { TrSaleComponent } from './components/rows/tr-sale.component';
import { FormSaleComponent } from './components/forms/form-sale.component';
import { CreatePurchaseOrderComponent } from './admin/pages/inventory/purchase-orders/create-purchase-order.component';
import { EditPurchaseOrderComponent } from './admin/pages/inventory/purchase-orders/edit-purchase-order.component';
import { IndexProviderComponent } from './admin/pages/inventory/providers/index-provider.component';
import { EditProviderComponent } from './admin/pages/inventory/providers/edit-provider.component';
import { CreateProviderComponent } from './admin/pages/inventory/providers/create-provider.component';
import { IndexPurchaseOrderComponent } from './admin/pages/inventory/purchase-orders/index-purchase-order.component';
import { IndexSalesComponent } from './admin/pages/inventory/sales/index-sales.component';
import { CreateSaleComponent } from './admin/pages/inventory/sales/create-sale.component';
import { EditSaleComponent } from './admin/pages/inventory/sales/edit-sale.component';
import { IndexPartsComponent } from './admin/pages/inventory/parts/index-parts.component';
import { EditPartComponent } from './admin/pages/inventory/parts/edit-part.component';
import { CreatePartComponent } from './admin/pages/inventory/parts/create-part.component';
import { FormPartComponent } from './components/forms/form-part.component';
import { TrPartComponent } from './components/rows/tr-part.component';
import { EditStockComponent } from './admin/pages/inventory/stock/edit-stock.component';
import { CreateStockComponent } from './admin/pages/inventory/stock/create-stock.component';
import { PurchaseOrderLineItemsComponent } from './admin/pages/inventory/purchase-orders/purchase-order-line-items.component';
import { TrPurchaseOrderLineItemComponent } from './components/rows/tr-purchase-order-line-item.component';
import { ModalPurchaseOrderComponent } from './components/inventory-modals/modal-purchase-order.component';
import { ModalSupplierComponent } from './components/inventory-modals/modal-supplier.component';
import { ModalPartComponent } from './components/inventory-modals/modal-part.component';
import { ModalStockLocationComponent } from './components/inventory-modals/modal-stock-location.component';
import { ModalStockItemComponent } from './components/inventory-modals/modal-stock-item.component';
import { ModalPartCategoryComponent } from './components/inventory-modals/modal-part-category.component';
import { ModalSalesOrderComponent } from './components/inventory-modals/modal-sales-order.component';
import { ModalReturnOrderComponent } from './components/inventory-modals/modal-return-order.component';
import { ModalLineItemComponent } from './components/inventory-modals/modal-line-item.component';
import { PartsCategoriesComponent } from './admin/pages/inventory/parts/parts-categories.component';
import { TrPartsCategoryComponent } from './components/rows/tr-parts-category.component';
import { TrSupplierComponent } from './components/rows/tr-supplier.component';
import { PurchaseOrderReceivedStockComponent } from './admin/pages/inventory/purchase-orders/purchase-order-received-stock.component';
import { PasswordStrengthMeterComponent } from 'angular-password-strength-meter';
import { provideZxvbnServiceForPSM } from 'angular-password-strength-meter/zxcvbn';
import { TenantUsersComponent } from './admin/pages/tenants/tenant-users.component';
import { NavbarComponent } from './shared/navbar.component';

import { ModalSettlementBillReportComponent } from './components/modals/modal-settlement-bill-report.component';
import { ModalSettlementStatementComponent } from './components/modals/modal-settlement-statement.component';
import { ModalUtilityZoneComponent } from './components/modals/modal-utility-zone.component';
import { ModalSearchTenantComponent } from './components/modals/modal-search-tenant.component';
import { OffcanvasTasksComponent } from './components/offcanvas/offcanvas-tasks.component';
import { TrUserComponent } from './components/rows/tr-user.component';
import { TrPerfilComponent } from './components/rows/tr-perfil.component';
import { TrRoleComponent } from './components/rows/tr-role.component';
import { IndexPermissionsComponent } from './admin/pages/permissions/index-permissions.component';
import { EditPermissionComponent } from './admin/pages/permissions/edit-permission.component';
import { CreatePermissionComponent } from './admin/pages/permissions/create-permission.component';
import { FormPermissionComponent } from './components/forms/form-permission.component';
import { TrBalanceComponent } from './components/rows/tr-balance.component';
import { TrContractComponent } from './components/rows/tr-contract.component';
import { IndexClientsComponent } from './admin/pages/inventory/clients/index-clients.component';
import { EditClientComponent } from './admin/pages/inventory/clients/edit-client.component';
import { CreateClientComponent } from './admin/pages/inventory/clients/create-client.component';
import { FormClientComponent } from './components/forms/form-client.component';
import { TrClientComponent } from './components/rows/tr-client.component';
import { IndexCompaniesComponent } from './admin/pages/inventory/companies/index-companies.component';
import { EditCompanyComponent } from './admin/pages/inventory/companies/edit-company.component';
import { CreateCompanyComponent } from './admin/pages/inventory/companies/create-company.component';
import { TrCompanyComponent } from './components/rows/tr-company.component';
import { FormCompanyComponent } from './components/forms/form-company.component';
import { ModalAddCompanyComponent } from './components/modals/modal-add-company.component';
import { NavInventoryComponent } from './components/navs/nav-inventory.component';
import { ModalProviderComponent } from './components/inventory-modals/modal-provider.component';
import { ItemInvoiceTenantComponent } from './components/items/item-invoice-tenant.component';
import { NavTenantBottomComponent } from './components/navs/nav-tenant-bottom.component';
import { IndexConsumeComponent } from './tenant/pages/tenant-consume/index-consume.component';
import { SmallConsumeLineChartComponent } from './components/charts/small-consume-line-chart.component';
import { ModalAddConceptBillComponent } from './components/modals/modal-add-concept-bill.component';
import { TrInvoicesComponent } from './components/rows/tr-invoices.component';
import { ModalEditGasMeterReadComponent } from './components/modals/modal-edit-gas-meter-read.component';
import { SettlementCalendarEventComponent } from './components/settlement-calendar-event.component';
import { UsersListComponent } from './components/settlement/users-list.component';
import { UsersFormComponent } from './components/settlement/users-form.component';
import { ReceiptInvoiceComponent } from './components/receipt-invoice.component';
import { TrSupplierItemComponent } from './components/rows/tr-supplier-item.component';
import { ModalSupplierItemComponent } from './components/inventory-modals/modal-supplier-item.component';
import { TrPurchaseOrderItemComponent } from './components/rows/tr-purchase-order-item.component';
import { FormCustomGasMeterReadComponent } from './components/forms/form-custom-gas-meter-read.component';
import { ModalEditTechnicianTaskComponent } from './components/modals/modal-edit-technician-task.component';
import { IndexStockAssignmentsComponent } from './admin/pages/inventory/stock-assignments/index-stock-assignments.component';
import { EditStockAssignmentsComponent } from './admin/pages/inventory/stock-assignments/edit-stock-assignments.component';
import { ModalStockAssignmentComponent } from './components/modals/modal-stock-assignment.component';
import { ProformaReportComponent } from './components/modals/proforma-report.component';
import { EditableDetailComponent } from './components/receipt-breakdown/editable-detail/editable-detail.component';
import { BillKeysUpdatePipe } from './pipes/bill-keys-update.pipe';
import { MeterReadFormatPipe } from './pipes/meter-read-format.pipe';
import { ZazzCalendarComponent } from './components/zazz-calendar/zazz-calendar.component';
import { CalendarTaskSummaryComponent } from './components/calendar-task-summary/calendar-task-summary.component';
import { RfcValidatorDirective } from './directives/rfc-validator.directive';
import { OperationsStartDateStatus } from './admin/pages/tenants/operations-start-date-status/operations-start-date-status';
import { UploadFile } from './components/upload-file/upload-file';
import { VideoPreview } from './components/video-preview/video-preview';
import { TankApprovals } from './components/tank-approvals/tank-approvals';
import { CardNumberDirective } from './directives/card-number.directive';
import { GasMeterApprovalsComponent } from './components/gas-meter-approvals/gas-meter-approvals.component';
import { InfiniteSelectSettlementsModule } from './components/inputs/infinite-select/infinite-select-settlements.module';
import { NavTanquesComponent } from './components/navs/nav-tanques.component';
import { ModalInventoryReportComponent } from './components/modals/modal-inventory-report.component';
import { ReportsResumeComponent } from './admin/pages/irregular-consumptions-report/reports-resume/reports-resume.component';
// import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';

initializeApp(environment.firebaseConfig);

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    ModalAddUnitComponent,
    SettlementComponent,
    UnitComponent,
    NavbarComponent,
    SidebarComponent,
    TenantsComponent,
    ServicesComponent,
    AmenitiesComponent,
    ProvidersComponent,
    PaymentsComponent,
    ReceiptsComponent,
    ServiceComponent,
    CargaRecibosComponent,
    UtilitesComponent,
    TenantComponent,
    OperationsStartDateStatus,
    SignInComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    VerifyEmailComponent,
    UsersComponent,
    RolesComponent,
    MaintenancesComponent,
    AmenityComponent,
    FormFloorComponent,
    FormUnitComponent,
    ProfileComponent,
    TenantSignInComponent,
    TenantSignUpComponent,
    PaymentComponent,
    TenantProfileComponent,
    TenantBillsComponent,
    TenantBillComponent,
    TenantPaymentsComponent,
    CheckoutComponent,
    TenantPaymentMethodsComponent,
    TenantPaymentMethodComponent,
    TenantDashboardComponent,
    TenantEditPaymentMethodComponent,
    TransactionSuccessComponent,
    ShowBillComponent,
    AuditTrailOffcanvasComponent,
    GodModeToggleComponent,
    BillTenantComponent,
    IndexSettlementComponent,
    TanquesComponent,
    TanqueCreateComponent,
    TanqueEditComponent,
    FormTanqueComponent,
    CreateSettlementComponent,
    FilterPipe,
    BuildingFloorsComponent,
    FormTenantComponent,
    ProviderCreateComponent,
    ProviderEditComponent,
    FormProvidersComponent,
    FormAmenityComponent,
    AmenityCreateComponent,
    ServiceCreateComponent,
    FormServiceComponent,
    FormUserComponent,
    RoleCreateComponent,
    RoleEditComponent,
    FormRoleComponent,
    ConfirmPasswordChangeComponent,
    ItemTenantComponent,
    ComercialSettlementsComponent,
    UnpaidComponent,
    ItemServiceComponent,
    ItemTinyTenantComponent,
    ItemTinyUserComponent,
    BillsSettlementComponent,
    TanqueGaugeComponent,
    ItemItemProviderComponent,
    ItemTransactionComponent,
    TechniciansComponent,
    TechnicianEditComponent,
    TechnicianCreateComponent,
    FormTechnicianComponent,
    ItemBillComponent,
    RefuelsComponent,
    OrdersComponent,
    ModalOptionsPayComponent,
    RefuelEditComponent,
    RefuelCreateComponent,
    OrderCreateComponent,
    OrderEditComponent,
    FormRefuelComponent,
    FormOrderComponent,
    InvoicesComponent,
    InvoiceCreateComponent,
    TenantInvoiceComponent,
    TenantInvoiceListComponent,
    ItemPaymentMethodComponent,
    ItemTanqueComponent,
    ItemOrderComponent,
    ReceiptBreakdownComponent,
    PaymentConceptsComponent,
    ConceptEditComponent,
    ConceptCreateComponent,
    FormPaymentConceptComponent,
    ItemConceptComponent,
    ItemFormConceptComponent,
    ReceiptReadsComponent,
    ItemInvoiceComponent,
    BillCommercialComponent,
    TaskCreateComponent,
    TaskEditComponent,
    FormTaskComponent,
    TaskIndexComponent,
    ModalAddBuildingComponent,
    CategoryIndexComponent,
    CategoryCreateComponent,
    CategoryEditComponent,
    FormTaskCategoryComponent,
    BillsTenantsComponent,
    BuildingUnitsComponent,
    UnitDetailsComponent,
    ItemTaskComponent,
    ItemTinyTaskComponent,
    CommercialsComponent,
    CommercialComponent,
    InvoiceShowComponent,
    AmenityCalendarComponent,
    AmenityTasksComponent,
    AmenityTaskCreateComponent,
    AmenityTaskEditComponent,
    InvoiceComplementComponent,
    InvoiceGlobalComponent,
    ItemBillPendingComponent,
    ModalInvoiceComplementComponent,
    ItemSettlementComponent,
    TenantInvoicesComponent,
    TenantInvoiceShowComponent,
    InvoiceCreateGlobalComponent,
    ItemBillInvoiceComponent,
    ProfileIndexComponent,
    ProfileEditComponent,
    ProfileCreateComponent,
    ProfileShowComponent,
    InvoiceDashboardComponent,
    FilterAdvancedComponent,
    InvoiceCreditnoteComponent,
    InvoiceCreditnoteCreateComponent,
    ItemProfileComponent,
    FormProfileComponent,
    ItemInvoiceGlobalComponent,
    ItemInvoiceNotaComponent,
    TenantUserEditComponent,
    FormConceptsComponent,
    ModalInvoiceNotaComponent,
    ItemCommercialComponent,
    FormAbilityComponent,
    FormReadingComponent,
    FormSettlementComponent,
    CurrencyToTextPipe,
    IndexZoneComponent,
    EditZoneComponent,
    CreateZoneComponent,
    FormZoneComponent,
    IndexReportsComponent,
    IndexBalancesComponent,
    GenerateComponent,
    ToolIndexComponent,
    ToolEditComponent,
    ToolCreateComponent,
    FormToolComponent,
    SkillIndexComponent,
    SkillEditComponent,
    SkillCreateComponent,
    VehiclesIndexComponent,
    VehiclesEditComponent,
    VehiclesCreateComponent,
    BuilderIndexComponent,
    BuilderEditComponent,
    BuilderCreateComponent,
    FormSkillComponent,
    FormVehicleComponent,
    FormBuilderComponent,
    ReceiptTinyComponent,
    ItemBalanceComponent,
    MeterIndexComponent,
    MeterEditComponent,
    MeterCreateComponent,
    FormGasMeterComponent,
    ItemGasMeterComponent,
    ItemTinyGasMeterComponent,
    ItemSkillComponent,
    ItemVehicleComponent,
    ItemToolComponent,
    ModalWorkScheduleComponent,
    ModalVehiclesComponent,
    ModalSkillsComponent,
    ModalToolsComponent,
    ActivityIndexComponent,
    ActivityEditComponent,
    ActivityCreateComponent,
    ActivityTypeIndexComponent,
    ActivityTypeEditComponent,
    ActivityTypeCreateComponent,
    FormActivityComponent,
    FormActivityTypeComponent,
    CountUpDirective,
    IndexChartComponent,
    BarChartComponent,
    DashboardSettlementComponent,
    DashboardTechniciansComponent,
    HolidaysComponent,
    ModalHolidayComponent,
    TaskReviewComponent,
    MapComponent,
    ItemRefuelComponent,
    ModalSetPriceComponent,
    InvoiceCanceledComponent,
    ItemInvoiceCanceledComponent,
    ModalInvoiceCancelComponent,
    InvoiceShowGlobalComponent,
    UserCreateComponent,
    ItemTaskTenantComponent,
    CalendarEventComponent,
    ItemPriceComponent,
    VideoPlayerComponent,
    NotificationsComponent,
    UnassignedComponent,
    ItemUnassignedComponent,
    TaskRefuelComponent,
    ModalAsignTaskComponent,
    ModalVehicleAsignComponent,
    DashboardCommercialComponent,
    GaugeChartComponent,
    NotifyFloaterComponent,
    ItemTaskRefuelComponent,
    ModalAsignTaskOperatorComponent,
    SearchTenantsComponent,
    TasksDashboardComponent,
    FilterBasicComponent,
    ModalInvoiceConfigComponent,
    InvoiceUploaderComponent,
    ItemSmTenantComponent,
    ModalTenantComponent,
    ModalGasMeterComponent,
    FilterFullComponent,
    InvoiceGenericComponent,
    ModalBillVerifyComponent,
    ItemInvoiceGenericComponent,
    TransactionFailComponent,
    CreateCustomBillComponent,
    BarChartConsumptionsComponent,
    PieChartPortfolioComponent,
    LineChartConsumptionComponent,
    ProfileDashboardComponent,
    TransactionsPaymentsComponent,
    ReportInvoicesIngresoComponent,
    ReportInvoicesCanceledComponent,
    ReportInventoryComponent,
    ReportInvoicesGlobalComponent,
    ReportInvoicesNotasComponent,
    ReportInvoicesGenericComponent,
    ModalInvoicesGenericComponent,
    ModalInvoicesCanceledComponent,
    ModalInvoicesGlobalComponent,
    ModalInvoicesIngresoComponent,
    ModalInvoicesNotasComponent,
    RefuelShowComponent,
    StlBarChartConsumptionsComponent,
    AnovaLineChartConsumptionsComponent,
    ItemBillPaidComponent,
    FilterSemiComponent,
    ModalGasMeterMaintenanceComponent,
    ContractUnitComponent,
    ContractSettlementComponent,
    ModalAddContractComponent,
    FormContractComponent,
    ItemContractComponent,
    FormPublicRecordComponent,
    SignInInvoiceComponent,
    ItemTenantInvoiceComponent,
    InvoiceAcceptanceComponent,
    ModalSetBillDateComponent,
    ModalSearchTenantComponent,
    ContractIndexComponent,
    ContractEditComponent,
    ContractTypesIndexComponent,
    ContractTypesEditComponent,
    ItemContractTypesComponent,
    FormContractTypesComponent,
    MeterUnitComponent,
    ModalGasMeterMaintenanceRemoveComponent,
    FormTenantFiscalComponent,
    FormTenantAddressComponent,
    FormUserPasswordComponent,
    ModalUserPasswordComponent,
    ModalUserFormComponent,
    TreeViewComponent,
    HistoricConsumptionsComponent,
    HistoricConsumptionsFormComponent,
    ModalUnitComponent,
    UnitPaymentsComponent,
    ModalAddFloorComponent,
    ItemBillTinyComponent,
    TenantUnitsComponent,
    FullFilterComponent,
    OffcanvasNavbarComponent,
    TrPaymentsComponent,
    TrTransactionsComponent,
    TrSettlementComponent,
    TenantUnitsComponent,
    ModalInvoicesGenericCanceledComponent,
    ReportInvoicesGenericCanceledComponent,
    IndexInventoryComponent,
    CreatePurchaseOrderComponent,
    EditPurchaseOrderComponent,
    IndexProviderComponent,
    EditProviderComponent,
    CreateProviderComponent,
    IndexPurchaseOrderComponent,
    FormPurchaseOrderComponent,
    FormProviderComponent,
    TrInventoryComponent,
    TrProviderComponent,
    TrPurchaseOrderComponent,
    TrTaskComponent,
    TrTanquesComponent,
    IndexSalesComponent,
    CreateSaleComponent,
    EditSaleComponent,
    TrSaleComponent,
    FormSaleComponent,
    IndexPartsComponent,
    EditPartComponent,
    CreatePartComponent,
    FormPartComponent,
    TrPartComponent,
    EditStockComponent,
    CreateStockComponent,
    PurchaseOrderLineItemsComponent,
    TrPurchaseOrderLineItemComponent,
    ModalPurchaseOrderComponent,
    ModalSupplierComponent,
    ModalPartComponent,
    ModalStockLocationComponent,
    ModalStockItemComponent,
    ModalPartCategoryComponent,
    ModalSalesOrderComponent,
    ModalReturnOrderComponent,
    ModalLineItemComponent,
    PartsCategoriesComponent,
    TrPartsCategoryComponent,
    TrSupplierComponent,
    TrOrderComponent,
    TrRefuelComponent,
    TrZonasComponent,
    TrTenantComponent,
    PurchaseOrderReceivedStockComponent,
    TenantUsersComponent,
    ModalSettlementBillReportComponent,
    ModalSettlementStatementComponent,
    ModalUtilityZoneComponent,
    NavPaymentsComponent,
    NavSettlementsComponent,
    NavTasksComponent,
    OffcanvasTasksComponent,
    TrUserComponent,
    TrPerfilComponent,
    TrRoleComponent,
    IndexPermissionsComponent,
    EditPermissionComponent,
    CreatePermissionComponent,
    FormPermissionComponent,
    TrBalanceComponent,
    TrContractComponent,
    IndexClientsComponent,
    EditClientComponent,
    CreateClientComponent,
    FormClientComponent,
    TrClientComponent,
    IndexCompaniesComponent,
    EditCompanyComponent,
    CreateCompanyComponent,
    TrCompanyComponent,
    FormCompanyComponent,
    ModalAddCompanyComponent,
    NavInventoryComponent,
    ModalProviderComponent,
    ItemInvoiceTenantComponent,
    NavTenantBottomComponent,
    IndexConsumeComponent,
    SmallConsumeLineChartComponent,
    ModalAddConceptBillComponent,
    TrInvoicesComponent,
    ModalEditGasMeterReadComponent,
    SettlementCalendarEventComponent,
    UsersListComponent,
    UsersFormComponent,
    ReceiptInvoiceComponent,
    TrSupplierItemComponent,
    ModalSupplierItemComponent,
    TrPurchaseOrderItemComponent,
    FormCustomGasMeterReadComponent,
    ModalEditTechnicianTaskComponent,
    IndexStockAssignmentsComponent,
    EditStockAssignmentsComponent,
    ModalStockAssignmentComponent,
    ProformaReportComponent,
    MeterReadFormatPipe,
    ReportsResumeComponent
  ],
  bootstrap: [AppComponent], 
  imports: [
    ContractHistoryComponent,
    LegalEntitySelectComponent,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    NgOptimizedImage,
    NgxPaginationModule,
    EmojiModule,
    CommonModule,
    FullCalendarModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    ColorPickerModule,
    NgxSkeletonLoaderModule,
    ToastrModule.forRoot(),
    PasswordStrengthMeterComponent,
    FormsModule,
    BreadcrumbComponent,
    BreadcrumbItemDirective,
    DndModule,
    EditableDetailComponent,
    ZazzCalendarComponent,
    CalendarTaskSummaryComponent,
    RfcValidatorDirective,
    CardNumberDirective,
    UploadFile,
    VideoPreview,
    TankApprovals,
    GasMeterApprovalsComponent,
    NavAdministrationComponent,
    NavTanquesComponent,
    ModalInventoryReportComponent,
    InfiniteSelectSettlementsModule,
    NavInvoicesComponent,
    InvoiceCsvExportButtonComponent
  ],
  providers: [
    BillKeysUpdatePipe,
    Papa, 
    HttpClient,
    RfcValidatorDirective,
    AuthService,
    provideZxvbnServiceForPSM(),
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule { }
